export const btReservations = [
    {
        id: 1,
        name: "Pendentes"
    },
    {
        id: 2,
        name: "Confirmadas"
    },
    {
        id: 3,
        name: "Recusadas"
    }
]